import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=6e15e0a2&"
import script from "./CommonTitle.vue?vue&type=script&lang=js&"
export * from "./CommonTitle.vue?vue&type=script&lang=js&"
import style0 from "./CommonTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports